<template>
  <div v-loading="isLoading">
    <div v-if="list && list.length > 0" class="my-table">
      <div class="table-item" v-for="(item, index) in list" :key="index" @click="toDetail(item)">
        <div class="content mt10">
          {{ item.Title }}
        </div>
        <div class="Prop">
          <span class="PropName">时间：</span><span class="PropValue time">{{ item.StartTime }} - {{ item.EndTime }}</span>
        </div>
        <div class="Prop mt5">
          <span class="PropName">地点：</span><span class="PropValue">{{ item.Address }}</span>
        </div>
      </div>
      <el-pagination class="center mt30 mb70" @current-change="(page) => getList(page)" background :page-size="18"
        hide-on-single-page layout="prev, pager, next" :total="count">
      </el-pagination>
    </div>
    <el-empty v-if="list.length == 0" description="暂无活动" :image="empty1" />
  </div>
</template>
<script>
import { Teacher_GetOthers } from "@/api/teacher";
export default {
  name: "TeacherCourse",
  data() {
    return { isLoading: false, PageIndex: 1, list: [], count: 0 };
  },
  props: {
    id: [String, Number],
  },
  watch: {
    id: {
      deep: true,
      handler(v) {
        this.getList(1);
        // this.list = v.map(item => ({ ...item, Ext: item.Ext.replace('.', ''), downLoading: false }))
      },
    },
  },
  components: {},
  created() {
    this.getList(1);
  },
  methods: {
    getList(page) {
      this.isLoading = true;
      Teacher_GetOthers({
        TeacherID: this.id,
        PageSize: 18,
        PageIndex: page,
      })
        .then((res) => {
          this.isLoading = false;
          this.list = res.data;
          this.count = res.count || this.list.length;
        })
        .catch(() => { });
    },
    toDetail(item) {
      // this.$router.push({
      //   path: "/courseDetail",
      //   query: { CourseID: item.CourseID },
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-table {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .table-item {
    cursor: pointer;
    width: 437px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #e9ecf0;
    padding: 15px;

    &:hover {
      transform: scale(1.01);
    }

    .content {
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 1;
      /* 显示的行数 */
      margin-bottom: 10px;
    }

    .Prop {
      .PropName {
        font-size: 16px;
        color: #999999;
      }

      .PropValue {
        font-size: 16px;
        color: #333333;
      }

      .time {
        color: #1d79ff;
        font-weight: bold;
      }
    }
  }
}
</style>
